import React, {useState, useEffect, Fragment} from 'react';
import {ListaNonConformita, ContactDetails, TextHighlight, AddButton, NewDeviceField, CheckIcon, UserIcon, BackButton, VisDiv, Photos, Comments,Loading, ViewLabelValueField, FieldDropdown, ClientDetailsReport} from '../components';
import { useStateContext } from '../context/StateContext';
import { useCreateReplace, useSet } from '../hooks/mutations';
import useNetworkStatus from '../hooks/useNetworkStatus';
import { successAlert, sortByLastName, siteAddress, gMapAddressLink, errorAlert  } from '../lib/utils';
import {FiMapPin } from 'react-icons/fi'





const SiteInfo = ({site, devices, deviceNonConformities, registerTemplate}) => {

    const {sites, setSite, setSites, client} = useStateContext();
    const networkStatus = useNetworkStatus()
    const originalSite = !Array.isArray(sites) ? undefined : sites?.find?.((x)=>x?._id == site?._id)
    //const [contactDetails, setContactDetails] = useState() 

    const siteDoc = {
        ...originalSite,
        image:[],
        images: [],
        comments: [],
        contactDetails: []
    }

    const contactDetails = !Array.isArray(site?.contactDetails) ? [] : site?.contactDetails?.filter?.((x)=>x?.status !== "ARCHIVIATO")?.sort(sortByLastName)

    const {mutate: setDocument} = useSet({onError:(e)=>{
        console.log("Document Created Or Updated", e?.message)
        errorAlert("ERRORE, Documento non aggiornato")
    
    }})
    const updatedSites = (updatedDoc) => {
        const siteList = !Array.isArray(sites) ? [] : sites 
        return [...siteList?.filter?.((x)=>x?._id !== updatedDoc?._id), updatedDoc]
    }
    const insertPictureSanity = (data) => {
        //console.log(data)
        const pictures = originalSite?.image ? originalSite?.image : []
        const newPictureDoc = {_id:originalSite?._id, image:[...pictures, data]}
        const queryDoc = {
            doc: newPictureDoc,
            fullDoc: {...originalSite, image:[...pictures, data]}
        }
        setDocument(queryDoc, {
            onSuccess:()=>{
                setSite(queryDoc?.fullDoc)
                setSites(updatedSites(queryDoc?.fullDoc))
            }
        })
    }

    const editComment = (data) => {
        //console.log(data)
        const comments = originalSite?.comments ? originalSite?.comments.filter?.(x=>x?._id !== data?._id) : []
        const newCommentDoc = {_id:originalSite?._id, comments:[...comments, data]}
        const queryDoc = {
            doc:  newCommentDoc,
            fullDoc: {...originalSite, comments:[...comments, data] }
        }
        setDocument(queryDoc, {
            onSuccess:()=>{
                setSite(queryDoc?.fullDoc)
                setSites(updatedSites(queryDoc?.fullDoc))

            }
        })
        
    }

    const saveContact = (data) => {
        console.log("SAVE CONTACT", data)
        const contacts = !Array.isArray(contactDetails) ? [] : contactDetails?.filter?.(x=>x?._id !== data?._id)
        const contactDoc = {_id:originalSite?._id, contactDetails:[...contacts, data] }
        const queryDoc = {
            doc:  contactDoc,
            fullDoc:  {...originalSite, contactDetails:[...contacts, data] }
        }
        setDocument(queryDoc, {
            onSuccess:()=>{
                setSite(queryDoc?.fullDoc)
                setSites(updatedSites(queryDoc?.fullDoc))

            }
        })
    }
    const clientDetails = {
        devices,
        deviceNonConformities, 
        hideLegenda: true, 
        hideClientsAndSites: true,
        //showToSupply: true,
        registerTemplate,
        client }

  return (
    <div className = "new-device-container">
    <div style={{display:"flex", flexDirection: "column", justifyContent:"center", alignItems:"center", marginBottom:"15px"}}>
        <h2>{site?.label}</h2>
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", marginBottom:"15px"}}>
            {siteAddress(site)}
            <VisDiv style={{marginLeft:"15px", cursor: "pointer"}} rules={[siteAddress(site)]}>
                <a href={gMapAddressLink(siteAddress(site))} target='_blank'>
                    <FiMapPin color={"#324d67"} size={30}/>
                </a>
            </VisDiv>
        </div>
    </div>
        <ClientDetailsReport data = {clientDetails}/>
        <ContactDetails saveFn={saveContact} contactDetails={contactDetails}/>

        <Photos
            destination={originalSite} 
            //saveFn = {insertPicture}
            saveSanityFn={insertPictureSanity}
        />
        <Comments
            destination={originalSite}
            editFn = {editComment}
            hideRead = {true}
        />
</div>
  )
}

export default SiteInfo
